import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
export function Masterclass() {
  return <section id="masterclass" className="py-14 md:py-20 bg-brand-warmwhite border-y border-brand-sand/30" data-id="element-103">
      <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-104">
        <FadeIn data-id="element-105">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-brand-ink mb-6" data-id="element-106">
            Masterclass gratuita: “Deja de vivir desconectada de ti y vuelve a
            tu esencia”.
          </h2>
          <p className="font-sans text-lg md:text-xl text-brand-eucalyptus font-medium mb-6 max-w-3xl mx-auto" data-id="element-107">
            Devela tu verdadero ser: Vuelve a ti más allá de tus heridas y
            condicionamientos.
          </p>
          <p className="font-sans text-brand-ink/80 max-w-2xl mx-auto mb-16 leading-relaxed" data-id="element-108">
            Un espacio breve y profundo para empezar a mirar tus patrones desde
            el Autoconocimiento, el Diseño Humano, la Gestión Emocional y el
            Desarrollo Espiritual.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-109">
          <div className="relative w-full max-w-4xl mx-auto aspect-video rounded-3xl overflow-hidden bg-brand-cream shadow-xl shadow-brand-ink/5 border border-brand-sand/50" data-id="element-110">
            <iframe src="https://player.vimeo.com/video/1204250146?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" title="Masterclass Helen" className="absolute inset-0 w-full h-full" data-id="element-111"></iframe>
          </div>

          <p className="font-sans text-sm text-brand-ink/60 mt-6 italic" data-id="element-112">
            Empieza por escucharte. Este espacio es para volver a ti sin
            exigencia, sin juicio y sin prisa.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="mt-12" data-id="element-113">
          <Button href="https://api.leadconnectorhq.com/widget/booking/kiMwaUwzHpX0z6UxKbPj" variant="primary" data-id="element-114">
            Agendar mi llamada de descubrimiento
          </Button>
        </FadeIn>
      </div>
    </section>;
}